import { parseColor } from './convert.js';

export function withAlpha(color: string, alpha: number): string {
  const rgb = parseColor(color);
  if (!rgb) return color;
  const a = Math.max(0, Math.min(1, alpha));
  return `rgba(${Math.round(rgb.r)}, ${Math.round(rgb.g)}, ${Math.round(rgb.b)}, ${a.toFixed(3).replace(/\.?0+$/, '')})`;
}

export function ghost(color: string, alpha = 0.08): string {
  return withAlpha(color, alpha);
}

export function getAlpha(color: string): number {
  const rgb = parseColor(color);
  return rgb ? rgb.a : 1;
}
